module.exports = __webpack_public_path__ + "img/yacht-4.db1ac202.jpg";